import { Component, OnInit } from "@angular/core";
import { AnalyticsHeaderService, ProjectService } from "@senior-gestao-pessoas/angular-components";
import { TourService } from "./core/utils/tour/tour.service";
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError } from "@angular/router";
import { filter } from "rxjs/operators";
import { AnalyticsService } from "./core/services/analytics.service";
import { PageLoadService } from "./core/services/page-load.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {

	public activeEmployees: any[];
	public isLoading = true;
	public isLoadingTour = false;
	public showTourBackground = false;

	constructor(private projectService: ProjectService,
				private headerService: AnalyticsHeaderService,
				private tourService: TourService,
				private router: Router,
				private analyticsService: AnalyticsService,
				private pageLoadService: PageLoadService) {
		this.projectService.setProject({ name: 'Analytics', app: 'gestao-pessoas', domain: 'hcm', service: 'analytics' });
		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.pageLoadService.setloadStartTime();
			}
		});
	}


	ngOnInit(): void {
		this.setupNavigationLoading();
		this.setupPersonActiveEmployees();
		this.setupTourBackground();
		this.setupDynamicLoadedCards();
	}

	private setupNavigationLoading() {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.isLoading = true;
			}
			if (event instanceof NavigationEnd ||
				event instanceof NavigationCancel ||
				event instanceof NavigationError) {
				this.isLoading = false;
			}
		});
	}

	private setupPersonActiveEmployees() {
		this.headerService.personActiveEmployeesSubject.subscribe((employees) => {
			this.activeEmployees = employees;
			this.isLoading = false;
		});
	}

	private setupTourBackground() {
		this.tourService.showTourSubject.subscribe((showTour) => this.showTourBackground = showTour);
	}

	private setupDynamicLoadedCards() {
		this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			new Promise((resolve) => {
				const analyticsRoute = this.router.config.filter(root => root.path === "analytics")[0];
				const childRoute = analyticsRoute.children.filter(child => {
					if (this.router.url && this.router.url !== "/") {
						let urlToSearch = this.router.url.replace('analytics/', '');
						if (urlToSearch.includes('?')) {
							urlToSearch = urlToSearch.substr(0, urlToSearch.indexOf('?'));
						}
						urlToSearch = urlToSearch.includes('led') ? 'led' : urlToSearch.substr(urlToSearch.indexOf('/') + 1);
						return child.loadChildren ? child.loadChildren.toString().toLowerCase().includes(urlToSearch.toLowerCase()) : false;
					}
					return false;
				});
				const loadedConfig = childRoute && childRoute.length ? (childRoute[0] as any)._loadedConfig : null;
				if (loadedConfig) {
					resolve(loadedConfig.routes);
				} else {
					resolve(null);
				}
			}).then((routes: any[]) => {
				if (routes) {
					this.analyticsService.cardsRoutesSubject.next(routes);
				}
			});
		});
	}
}
